import styled from "styled-components";

export const ToastViewPortWrapper = styled.div`
    position: fixed;
    z-index: 9999;
    display: flex;
    flex-direction: column;
    gap: 8px;
    pointer-events: none;
    width: 100%;
    
    & > * {
        pointer-events: auto;
    }
    
    ${({ $position }) => {
        return `
            bottom: ${$position.includes('bottom') ? '16px' : 'auto'};
            top: ${$position.includes('top') ? '16px' : 'auto'};
            right: ${$position.includes('right') ? '16px' : 'auto'};
            left: ${$position.includes('left') ? '16px' : 'auto'};
        `;
    }}
`;
